export const styles = {
    backgrounds: [
        { className: "primary-bg-colour", colour: "#9a3ddc" },
        { className: "secondary-bg-colour", colour: "#1f1f1f" },
        { className: "tertiary-bg-colour", colour: "#262626" },
        { className: "inactive-bg-colour", colour: "#141414" },
        { className: "misc-bg-colour", colour: "#4444441f" },
        { className: "gold-bg-colour", colour: "#ffd949" },
        { className: "black-bg-colour", colour: "#000000" },
    ],
    text: [
        { className: "primary-text", colour: "#ffffff" },
        { className: "secondary-text", colour: "#000000" },
        { className: "tertiary-text", colour: "#bdbdbd" },
        { className: "inactive-text", colour: "#696969" },
        { className: "misc-text", colour: "#9a3ddc" },
        { className: "gold-text-colour", colour: "#ffd949" },
        { className: "win-text", colour: "#00cc00" },
        { className: "lose-text", colour: "#ff0000" },
        { className: "draw-text", colour: "#808080" },
    ],
    borders: [
        { className: "primary-border-colour", colour: "#9a3ddc" },
        { className: "secondary-border-colour", colour: "#1f1f1f" },
        { className: "gold-border-colour", colour: "#ffd949" },
        { className: "primary-free-border-colour", colour: "#44444440" },
    ],
};
